import { render, staticRenderFns } from "./SkinAndScubaDivingQuestionnaireCN.vue?vue&type=template&id=94841fb2"
import script from "./SkinAndScubaDivingQuestionnaireCN.vue?vue&type=script&lang=js"
export * from "./SkinAndScubaDivingQuestionnaireCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports